import React from 'react';
import {
  Box,
  BoxProps,
  Container,
  Heading,
  SimpleGrid,
} from '@hover/blueprint';
import type { StyleProps } from '@chakra-ui/react';
import LearningCard from '../../learning-card';
import type { ILearningCardProps } from '../../learning-card';

export const wrapperStyle: StyleProps = {
  w: '100%',
  alignItems: 'center',
  bg: { base: 'brandNavy.100', desktop: 'none' },
  pt: { base: 900, desktop: 0 },
  mt: '15px',
  mb: { base: '56px', tablet: 1000, desktop: '76px' },
};

export const headingStyle: StyleProps = {
  marginBottom: { base: 400, tablet: '52px', desktop: '52px' },
  textAlign: { base: 'center' },
};

interface IResourcesProps extends BoxProps {
  items: ILearningCardProps['card'][];
  maxWidth?: string;
  columns?: { base: number; tablet: number; desktop: number };
}

const Resources: React.FC<IResourcesProps> = ({
  items,
  maxWidth,
  columns,
  ...props
}) => {
  const containerStyle: StyleProps = {
    maxW: maxWidth || '1200px',
    px: { base: 500, tablet: '56px' },
    pb: { base: 700, tablet: '98px', desktop: '114px' },
  };

  return (
    <Box {...wrapperStyle} {...props}>
      <Container {...containerStyle}>
        <Heading
          as="h2"
          isLight
          size={{ base: 500, tablet: 600, desktop: 700 }}
          {...headingStyle}
        >
          Resources
        </Heading>
        <SimpleGrid
          spacingX={{ base: 400, desktop: 600 }}
          spacingY={{ base: 300, desktop: 0 }}
          columns={columns || { base: 1, tablet: 2, desktop: 4 }}
          justifyItems="center"
        >
          {items.map((cardItem, index) => (
            <LearningCard
              maxWidth="370px"
              w="100%"
              card={cardItem}
              key={cardItem.id}
              cardIndex={index}
            />
          ))}
        </SimpleGrid>
      </Container>
    </Box>
  );
};

export default Resources;
